import { render, staticRenderFns } from "./G2Popover.vue?vue&type=template&id=d499afe6&scoped=true&"
import script from "./G2Popover.vue?vue&type=script&lang=js&"
export * from "./G2Popover.vue?vue&type=script&lang=js&"
import style0 from "./G2Popover.vue?vue&type=style&index=0&id=d499afe6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d499afe6",
  null
  
)

export default component.exports